import { createContext, useContext } from 'react';

/** Opens the full-screen AI Assistant; null outside `AssistantProvider`. */
export const AssistantContext = createContext<(() => void) | null>(null);

/** The opener of the AI Assistant, or null when no provider is mounted. */
export const useOpenAssistant = () => useContext(AssistantContext);
